import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
// import useCountValue from './selectors'
import {GETSINGLECITY_CONTENT} from './actionTypes'
import fetchData, {fetchContent} from '../../utils/fetch-data'
// eslint-disable-next-line import/no-named-as-default
import getUrlParameter from '../../utils/getUrlParameter'
// import config from '../../config'

// async function getSingleCityContent (baseUrlAlias) {
//   try {
//     const cityContent = await fetchContent(`/${baseUrlAlias}/city-info-frame/ajax/1/sc/1`)
//     // window.location.href = `/${closestCity}?src=hr&country=${countryCode}`
//     return cityContent
//   } catch (e) {
//     throw new Error('No redirect by no ip detect by desktop')
//   }
//
// }
const postParameter = () => {
  if (getUrlParameter('tb') == 1) return '?tb=1'
  if (getUrlParameter('xtb') == 1) return '?xtb=1'
  return ''
}

const useActionsCity = () => {
  const dispatch = useDispatch()
  const getSingleCity = useCallback(
    baseUrlAlias => {
      // const cityContent = await getSingleCityContent(baseUrlAlias)
      // const post = getUrlParameter('tb') == 1 ? '?tb=1' : ''
      dispatch({
        type: GETSINGLECITY_CONTENT,
        // value: getSingleCityContent (baseUrlAlias),
        payload: fetchContent(`/${baseUrlAlias}/city-info-frame/ajax/1/sc/1${postParameter()}`),
      })
    },
    [dispatch]
  )
  return {getSingleCity}
}

export default useActionsCity
